import * as React from 'react'
import { useEffect, useState } from 'react'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop'
import MaterialTable from 'material-table'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../../snackbar/Snackbar'
import { initialNotificationState } from '../../utils/state/ApplicationState'
import { createDateFromString } from '../../utils/DateUtils'
import { getApiUrl } from '../../../api/api'

const columns = [
  { field: 'tenantFullName', title: 'Name' },
  {
    field: 'tenantEmail',
    title: 'Email',
    render: (rowData) => <a href={`mailto:${rowData.tenantEmail}`}> {rowData.tenantEmail} </a>,
  },
  { field: 'tenantRoom', title: 'Zimmer' },

  {
    field: 'departureDate',
    title: 'Auszug',
    customSort: (a, b) => createDateFromString(a.departureDate) - createDateFromString(b.departureDate),
  },
]

export default function AdminCreatedDepartureTable() {
  const [notification, setNotification] = useState(initialNotificationState)
  const [proceeding, setProceeding] = useState(true)
  const [departures, setDepartures] = useState([])

  useEffect(() => {
    let params = new URLSearchParams()
    params.append('status', 'CREATED')
    getApiUrl(params)
      .get(`/admin/departures`)
      .then(function(response) {
        setProceeding(false)
        setDepartures(response.data)
      })
      .catch(function(error) {
        console.log(error)
      })
  }, [])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={departures}
          title=""
          actions={[
            {
              icon: 'mail',
              tooltip: 'Erinnerung senden',
              onClick: (event, rowData) => {
                getApiUrl()
                  .put(
                    `/admin/departures/${rowData.departureId}/reminder`,
                    {},
                  )
                  .then(() => {
                    setNotification({
                      open: true,
                      message: 'Bewohner wurde informiert',
                      color: 'success',
                    })
                  })
                  .catch((error) =>
                    setNotification({
                      open: true,
                      message: error.response.data.message,
                      color: 'danger',
                    }),
                  )
                event.stopPropagation()
              },
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            header: {
              actions: 'Aktion',
            },
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
